import { FC, useCallback } from 'react';
import { Stack } from '@mui/material';

import { useStoryCrud } from '../hooks/useStoryCrud';

import { FormCrud, StoryForm } from './StoryForm/StoryForm';
import { StoryHeader } from './StoryHeader';


interface ViewProps {
  onSuccess?: (story: Stories.Story) => void;
}

export const CreateStoryPartial: FC<ViewProps> = (props) => {
  const { onSuccess } = props;

  const { createStory } = useStoryCrud();

  const onSubmit = useCallback(async (data: FormCrud) => {
    try {
      const response = await createStory.mutateAsync(data);
      onSuccess?.(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [createStory, onSuccess]);

  return (
    <Stack gap={2} width="100%">
      <StoryHeader title=" Create Story" isSaving={createStory.isPending}/>
      <StoryForm onSubmitRequest={onSubmit}/>
    </Stack>
  );
};
